import React from "react";

export const ListIcon = (props:React.SVGProps<SVGSVGElement> & {size?:number|string}) => (
  <svg {...props} width={props.width || props.size || 30} height={props.height || props.size || 30} viewBox="0 0 50 50" fill={props.fill || "none"} xmlns="http://www.w3.org/2000/svg">
    <path d="M38.73 43.36H11.27V6.64h15.92c6.37 0 11.56 5.17 11.56 11.56v25.16h-.02zM16.55 36.16h16.9M16.55 21.55h16.9M16.55 14.23h13.73M16.55 28.84h16.9" stroke="CurrentColor" strokeWidth={props.strokeWidth || "1"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);